// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as LotInfo$LiveRoom from "./LotInfo.bs.js";
import * as LotContent$LiveRoom from "./LotContent.bs.js";

function MiddleSection(props) {
  var lot = props.fragment;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.overflowY(Css.auto),
                    tl: /* [] */0
                  })
            }, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.overflow("hidden"),
                        tl: {
                          hd: Css.justifyContent("center"),
                          tl: {
                            hd: Css.width(Css.pct(100)),
                            tl: {
                              hd: Css.padding(Css.px(48)),
                              tl: /* [] */0
                            }
                          }
                        }
                      })
                }, React.createElement("div", undefined, Belt_Option.getWithDefault(props.carousel, null), React.createElement(LotInfo$LiveRoom.make, {
                          lotNumber: lot.lotNumber,
                          creators: lot.creatorsDisplayNames,
                          title: lot.title,
                          subtitle: lot.subtitle,
                          lotTags: lot.lotTags,
                          parcel: lot.parcel,
                          useCreatorSplit: lot.auction.useCreatorSplit
                        })), React.createElement(LotContent$LiveRoom.make, {
                      lot: lot,
                      me: props.me
                    })));
}

var make = MiddleSection;

export {
  make ,
}
/* Css Not a pure module */
